import { render, staticRenderFns } from "./TempletIndex.vue?vue&type=template&id=d4f04cfa&"
import script from "./TempletIndex.vue?vue&type=script&lang=js&"
export * from "./TempletIndex.vue?vue&type=script&lang=js&"
import style0 from "./TempletIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports